import * as React from 'react';
import { IconProps } from '../types';

const IcCamera = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill={props?.fill ?? '#232F3E'}
        fillRule="evenodd"
        d="M8.292 2.445A1 1 0 0 1 9.124 2h6a1 1 0 0 1 .832.445L17.659 5h3.465a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3h-18a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.465l1.703-2.555ZM9.659 4 7.956 6.555A1 1 0 0 1 7.124 7h-4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4a1 1 0 0 1-.832-.445L14.589 4h-4.93Zm2.465 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.124 0h24v24h-24z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcCamera;
